/*
 * サブシステム名：傭車明細
 * 機能名：傭車明細一覧
 */

import DdCustomButton from '@/components/DdCustomButton'
import DdTransparentButton from '@/components/DdTransparentButton'

import DdCheckbox from '@/components/DdCheckbox.vue'
import DdDataTable from '@/components/DdDataTable'
import DdDateBox from '@/components/DdDateBox'
import DdNumericBox from '@/components/DdNumericBox'
import DdRadioButton from '@/components/DdRadioButton'
import DdRadioSwitchTwoway from '@/components/DdRadioSwitchTwoway'
import DdRowCountBox from '@/components/DdRowCountBox'
import DdSpreadSheet from '@/components/DdSpreadSheet'
import DdSubHeader from '@/components/DdSubHeader'
import DdTextBox from '@/components/DdTextBox.vue'
import DdTextBoxPlaceHolderFree from '@/components/DdTextBoxPlaceHolderFree'

import flowMixin from '@/mixins/flowMixins'

import date from '@/ddv2.library/date'
import modals from '@/ddv2.library/modals'
import filter from '@/rahmen/utils/filters'
import message from '@/ddv2.library/messages'

import { mapGetters } from 'vuex'

export default {
  name: 'YoshaMeisaiListEdit',
  mixins: [flowMixin],
  components: {
    DdCustomButton,
    DdTransparentButton,

    DdCheckbox,
    DdDataTable,
    DdDateBox,
    DdNumericBox,
    DdRadioButton,
    DdRadioSwitchTwoway,
    DdRowCountBox,
    DdSpreadSheet,
    DdSubHeader,
    DdTextBox,
    DdTextBoxPlaceHolderFree
  },
  data: () => ({
    rows: [],
    headers: [],
    headerType: 'D2PAYD1020',
    params: {},
    shiharaiKihon: {},
    shiharaisaki: {},
    isExistsKeshikomi: false,
    expansionPanel: [0, 1],
    shiharaisakiCdNmText: '',
    tokuisakiCdNmText: '',
    eigyoshoCdNmText: '',
    shimeDateText: '',
    shiharaishoText: '',
    nippoStyleNormal: false,
    conditions: {
      shiharaiYmd: '',
      shiharaiYm: '',
      shimeDay: '',
      shiborikomiStartYmd: '',
      shiborikomiEndYmd: '',
      shiharaisakiId: '',
      eigyoshoId: '',
      shiharaishoKarihakkoFlg: false,
      kingakuZeroFlg: false,
      kingakuKakutei: '01',
      shimebiIgaiHyojiFlg: false,
      shiharaiDomeHyojiFlg: false
    },
    yoshaSum: {
      kihonUnchin: 0,
      jikanWarimashiKingaku: 0,
      kyoriWarimashiKingaku: 0,
      warimashiSonotaKingaku: 0,
      unchinHokaKingaku: 0,
      hiwayPrice: 0,
      unchinHokaHikazei: 0
    },
    itemsPerPage: 100,
    page: 1,
    isXlsDownloader: false,
    modeKengen: 0,
    // 表示制御
    isConditionHide: false,
    dispShiharaisho: '',
    // スプレッドシートオプション
    option: {
      // テーブル最大高さ
      tableHeight: '100%',
      // テーブル最大横幅
      tableWidth: 'inherit',
      // 列固定
      freezeColumns: 2,
      // 列追加
      allowInsertColumn: false,
      // 行追加※改行キーのみ
      allowManualInsertRow: false,
      // 列削除
      allowDeleteColumn: false,
      // 行削除
      allowDeleteRow: false,
      // 列ドラッグ
      columnDrag: false,
      // 行ドラッグ
      rowDrag: false,
      // ソート
      columnSorting: true,
      // スクロール有効化
      tableOverflow: true,
      // コンテキストメニュー
      contextmenu: false,
      // セル内HTML無効※ヘッダー改行のため有効
      stripHTML: false,
      // 計算式のサポート
      parseFormulas: true,
      // セル選択時の右下の■ドラッグでのコピー
      selectionCopy: true,
      // CSV出力
      allowExport: false,
      // フィルターオプション
      search: true,
      // ページネーションオプション
      pagination: 25,
      paginationOptions: [10, 25, 50, 100, 150, 200],
      // デフォルト文言変更
      text: {
        show: '1ページ当たりの行数:',
        entries: '',
        showingPage: '全部で {1} ページあります',
        search: 'さらにフリーワードで絞り込む',
        noRecordsFound: '対象データがありません'
      }
    },
    // 画面側からのエラーリスト
    outsideErrorList: []
  }),
  computed: {
    ...mapGetters({
      viewTitle: 'system/viewTitle',
      torihikisakiList: 'DDMasters/mstTorihikisaki',
      hacchakuchiList: 'DDMasters/mstHacchakuchi',
      hinmeiList: 'DDMasters/mstHinmei',
      kubunList: 'DDMasters/msysKubun',
      shubetsuList: 'DDMasters/mstShubetsu',
      taxList: 'DDMasters/msysTax',
      xlsImportMappingList: 'DDMasters/mstXlsImportMapping',
      helpUseFlg: 'DDMasters/helpUseFlg'
    }),
    isOutputButtonDisabled () {
      return this.rows.length === 0
    },
    isBatchRegisterButtonDisabled () {
      if (this.modeKengen !== 2) {
        return false
      }
      const errorRows = this.rows.filter(function (elem) {
        return elem.errFlg === true
      })
      if (errorRows.length > 0) {
        return true
      }
      return false
    },

    isShiharai () {
      return this.params.shiharaisho !== '未出力'
    },
    isShiharaiTorikeshi () {
      return this.params.shiharaisho === '取消済'
    },
    isKarihakko () {
      return this.params.kariHakkoFlg
    },
    isNotExistShiharaishoLayoutKbn () {
      return !this.shiharaisaki.shiharaishoLayoutKbn && !this.shiharaisaki.shiharaiMeisaishoLayoutKbn
    },
    isNoParam () {
      return Object.keys(this.params).length === 0
    },
    isShoukaiMode () {
      return this.modeKengen === 0
    },
    isBikoButtonDisp () {
      return this.isShiharai && !this.isNoParam
    },
    isPrintAgainButtonDisp () {
      return this.isShiharai && !this.isShiharaiTorikeshi && !this.isNoParam
    },
    isCancelButtonDisp () {
      return this.isShiharai && !this.isShiharaiTorikeshi && !this.isKarihakko && this.modeKengen === 2 && !this.isNoParam
    },
    isPrintButtonDisp () {
      return !this.isShiharai && !this.isShoukaiMode && !this.isNoParam
    },
    apiPathSearch () {
      var path = ''
      if (this.params.shiharaisho === '未出力') {
        // 未支払（発注情報）の場合
        path = '/api/v1/d2payd0020/searchMiShiharaiMeisaiEditList'
      } else {
        path = '/api/v1/d2payd0020/SearchShiharaiMeisaiEditList'
      }
      return path
    },
    shiharaishoStatusColor () {
      if (this.conditions.shiharaishoKarihakkoFlg) {
        return 'green'
      } else if (this.conditions.shiharaisho === '取消済') {
        return 'gray'
      } else if (this.conditions.shiharaisho === '出力済') {
        return 'blue'
      } else {
        return 'white'
      }
    },
    shiharaishoStatusText () {
      if (this.conditions.shiharaishoKarihakkoFlg) {
        return '仮発行済'
      } else if (this.conditions.shiharaisho === '取消済') {
        return '取消済'
      } else if (this.conditions.shiharaisho === '出力済') {
        return '本発行済'
      } else {
        return '未出力'
      }
    },
    computedColNumList () {
      var result = {}
      this.headers.forEach((elem, index) => {
        result[elem.name] = index
      })
      return result
    },
    spreadDescription () {
      // 必要に応じて
      // return '<div style="padding:4px;font-weight:bold;color:red;">(*)がある列は必須項目です</div>'
      return null
    },
    allKazeiGokei () {
      let kazeiSum = 0

      this.rows.forEach(item => {
        const fields = [
          'meisaiKihonUnchin',
          'meisaiJikanWarimashiKingaku',
          'meisaiKyoriWarimashiKingaku',
          'meisaiKeisuWarimashiKingaku',
          'meisaiNenryoWarimashiKingaku',
          'meisaiNenryoSurcharge',
          'meisaiTsumikomiKingaku',
          'meisaiTorioroshiKingaku',
          'meisaiTaikiJikanKingaku',
          'meisaiFutaiGyomuKingaku',
          'meisaiFutaiGyomuKingaku1',
          'meisaiFutaiGyomuKingaku2',
          'meisaiFutaiGyomuKingaku3',
          'meisaiFutaiGyomuKingaku4',
          'meisaiFutaiGyomuKingaku5',
          'meisaiFutaiGyomuKingaku6',
          'meisaiFutaiGyomuKingaku7',
          'meisaiFutaiGyomuKingaku8',
          'meisaiFutaiGyomuKingaku9',
          'meisaiFutaiGyomuKingaku10',
          'meisaiUserKingakuKazei1',
          'meisaiUserKingakuKazei2',
          'meisaiUserKingakuKazei3',
          'meisaiUserKingakuKazei4',
          'meisaiUserKingakuKazei5',
          'meisaiUserKingakuKazei6',
          'meisaiUserKingakuKazei7',
          'meisaiUserKingakuKazei8',
          'meisaiUserKingakuKazei9',
          'meisaiUserKingakuKazei10',
          'hinmokuKihonUnchin',
          'hinmokuJikanWarimashiKingaku',
          'hinmokuKyoriWarimashiKingaku',
          'hinmokuKeisuWarimashiKingaku',
          'hinmokuNenryoWarimashiKingaku',
          'hinmokuNenryoSurcharge',
          'hinmokuTsumikomiKingaku',
          'hinmokuTorioroshiKingaku',
          'hinmokuTaikiJikanKingaku',
          'hinmokuFutaiGyomuKingaku',
          'hinmokuFutaiGyomuKingaku1',
          'hinmokuFutaiGyomuKingaku2',
          'hinmokuFutaiGyomuKingaku3',
          'hinmokuFutaiGyomuKingaku4',
          'hinmokuFutaiGyomuKingaku5',
          'hinmokuFutaiGyomuKingaku6',
          'hinmokuFutaiGyomuKingaku7',
          'hinmokuFutaiGyomuKingaku8',
          'hinmokuFutaiGyomuKingaku9',
          'hinmokuFutaiGyomuKingaku10',
          'hinmokuUserKingakuKazei1',
          'hinmokuUserKingakuKazei2',
          'hinmokuUserKingakuKazei3',
          'hinmokuUserKingakuKazei4',
          'hinmokuUserKingakuKazei5',
          'hinmokuUserKingakuKazei6',
          'hinmokuUserKingakuKazei7',
          'hinmokuUserKingakuKazei8',
          'hinmokuUserKingakuKazei9',
          'hinmokuUserKingakuKazei10'
        ]

        fields.forEach(f => {
          if (![undefined, null, '0', ''].includes(item[f])) {
            kazeiSum += Number(item[f])
          }
        })

        // meisaiHanyoKingaku1〜5 は対応する 税区分が '01' の場合のみ加算
        for (let i = 1; i <= 5; i++) {
          const kingakuKey = `meisaiHanyoKingaku${i}`
          const zeiKey = `meisaiHanyoKingakuZeiKbn${i}`
          if (item[zeiKey] === '01' && ![undefined, null, ''].includes(item[kingakuKey])) {
            kazeiSum += Number(item[kingakuKey])
          }
        }

        // hinmokuHanyoKingaku1〜5 は対応する 税区分が '01' の場合のみ加算
        for (let i = 1; i <= 5; i++) {
          const kingakuKey = `hinmokuHanyoKingaku${i}`
          const zeiKey = `hinmokuHanyoKingakuZeiKbn${i}`
          if (item[zeiKey] === '01' && ![undefined, null, ''].includes(item[kingakuKey])) {
            kazeiSum += Number(item[kingakuKey])
          }
        }
      })

      return kazeiSum
    },
    allKazeiGokeiDisp () {
      // 合計金額の表示
      return filter.numericFormatter(this.allKazeiGokei)
    },
    allHikazeiGokei () {
      let hikazeiSum = 0

      this.rows.forEach(item => {
        const fields = [
          'meisaiHiwayPrice',
          'meisaiUserKingakuHikazei1',
          'meisaiUserKingakuHikazei2',
          'meisaiUserKingakuHikazei3',
          'meisaiUserKingakuHikazei4',
          'meisaiUserKingakuHikazei5',
          'meisaiUserKingakuHikazei6',
          'meisaiUserKingakuHikazei7',
          'meisaiUserKingakuHikazei8',
          'meisaiUserKingakuHikazei9',
          'meisaiUserKingakuHikazei10',
          'meisaiUserKingakuUchizei1',
          'meisaiUserKingakuUchizei2',
          'meisaiUserKingakuUchizei3',
          'meisaiUserKingakuUchizei4',
          'meisaiUserKingakuUchizei5',
          'meisaiUserKingakuUchizei6',
          'meisaiUserKingakuUchizei7',
          'meisaiUserKingakuUchizei8',
          'meisaiUserKingakuUchizei9',
          'meisaiUserKingakuUchizei10',
          'hinmokuHiwayPrice',
          'hinmokuUserKingakuHikazei1',
          'hinmokuUserKingakuHikazei2',
          'hinmokuUserKingakuHikazei3',
          'hinmokuUserKingakuHikazei4',
          'hinmokuUserKingakuHikazei5',
          'hinmokuUserKingakuHikazei6',
          'hinmokuUserKingakuHikazei7',
          'hinmokuUserKingakuHikazei8',
          'hinmokuUserKingakuHikazei9',
          'hinmokuUserKingakuHikazei10',
          'hinmokuUserKingakuUchizei1',
          'hinmokuUserKingakuUchizei2',
          'hinmokuUserKingakuUchizei3',
          'hinmokuUserKingakuUchizei4',
          'hinmokuUserKingakuUchizei5',
          'hinmokuUserKingakuUchizei6',
          'hinmokuUserKingakuUchizei7',
          'hinmokuUserKingakuUchizei8',
          'hinmokuUserKingakuUchizei9',
          'hinmokuUserKingakuUchizei10'
        ]

        fields.forEach(f => {
          if (![undefined, null, '0', ''].includes(item[f])) {
            hikazeiSum += Number(item[f])
          }
        })

        // meisaiHanyoKingaku1〜5 は対応する 税区分が '01'以外 の場合のみ加算
        for (let i = 1; i <= 5; i++) {
          const kingakuKey = `meisaiHanyoKingaku${i}`
          const zeiKey = `meisaiHanyoKingakuZeiKbn${i}`
          if (item[zeiKey] !== '01' && ![undefined, null, ''].includes(item[kingakuKey])) {
            hikazeiSum += Number(item[kingakuKey])
          }
        }

        // hinmokuHanyoKingaku1〜5 は対応する 税区分が '01'以外 の場合のみ加算
        for (let i = 1; i <= 5; i++) {
          const kingakuKey = `hinmokuHanyoKingaku${i}`
          const zeiKey = `hinmokuHanyoKingakuZeiKbn${i}`
          if (item[zeiKey] !== '01' && ![undefined, null, ''].includes(item[kingakuKey])) {
            hikazeiSum += Number(item[kingakuKey])
          }
        }
      })

      return hikazeiSum
    },
    allHikazeiGokeiDisp () {
      return filter.numericFormatter(this.allHikazeiGokei)
    },
    taxPrice () {
      const target = filter.dateFormatter(new Date())
      const tax = this.taxList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      })

      return Math.round(this.allKazeiGokei * (tax[0].taxPer / 100))
    },
    taxPriceDisp () {
      return filter.numericFormatter(this.taxPrice)
    },
    allUnchinGokeiDisp () {
      // 合計金額の表示
      return filter.numericFormatter(this.allKazeiGokei + this.allHikazeiGokei + this.taxPrice)
    }
  },

  created () {
    this.params = this.$route.params
    // エクセルレイアウトは常に最新を取得
    this.$store.dispatch('DDMasters/truncateMasters', { list: ['mstxlsimportmapping'] }).then(() => {
      this.$store.dispatch('DDMasters/loadMasters', { list: ['mstxlsimportmapping'], version: 1, kinoId: 0 }).then(() => {
        this.initialize()
      })
    })
  },
  mounted () {
    // エクセルレイアウトは常に最新を取得
    this.$store.dispatch('DDMasters/truncateMasters', { list: ['mstxlsimportmapping'] }).then(() => {
      this.$store.dispatch('DDMasters/loadMasters', { list: ['mstxlsimportmapping'], version: 1, kinoId: 0 }).then(() => {
        this.initialize()
      })
    })
  },
  beforeRouteUpdate (to, from, next) {
    this.$refs.initialize()
    next()
  },
  methods: {
    getCloneTargetMethod: function () {
      return {}
    },
    initialize: function () {
      const self = this
      const opt = {
        loadMasters: ['msttorihikisaki', 'msthinmei', 'msthacchakuchi', 'msyskubun', 'mstshubetsu', 'msystax'],
        defineHeaderPromise: () => {
          return new Promise(resolve => {
            self.setHeader()
            resolve()
          })
        },
        initializeInputPromise: function () {
          return new Promise((resolve) => {
            if (self.isNoParam) {
              // 傭車明細一覧画面からパラメータが渡されていない（当画面をリロードした）場合
              // 傭車明細一覧画面から受け取ったパラメータをキャッシュから再現するようにしている
              self.loadFromCache()
                .then((c) => {
                  self.params = c.value.params || {}
                  resolve()
                })
            } else {
              resolve()
            }
          })
        },
        settingButtonStatePromise: (kengen) => {
          return new Promise(resolve => {
            if (kengen.kengenKbn === '10') {
              // 読取モード
              self.modeKengen = 0
            } else if (kengen.kengenKbn === '20') {
              // 削除不可モード
              self.modeKengen = 1
            } else {
              // フルアクセス
              self.modeKengen = 2
            }
            self.$nextTick(() => {
            })
            resolve()
          })
        },
        savedInputRestorePromise: (c) => {
          self.conditions = { ...self.conditions, ...c }
          var shimebiIgaiHyojiFlgBool = c.shimebiIgaiHyojiFlg === 'true'
          self.conditions.shimebiIgaiHyojiFlg = shimebiIgaiHyojiFlgBool
          var shiharaiDomeHyojiFlgBool = c.shiharaiDomeHyojiFlg === 'true'
          self.conditions.shiharaiDomeHyojiFlg = shiharaiDomeHyojiFlgBool
          return new Promise(resolve => {
            self.loadFromCache()
              .then((c) => {
                // 画面起動時に検索するため、ユーザ保存項目を復元してから検索する
                self.initSearch()
                  .then(() => {
                    resolve()
                  })
                // resolve()
              })
          })
        },
        researchPromise: (c) => {
          return new Promise(resolve => {
            self.conditions = c.cache.value ? c.cache.value.conditions || {} : self.conditions
            self.onSearchButtonClick()
            resolve()
          })
        },
        restoreViewPromise: (c) => {
          return new Promise(resolve => {
            self.conditions = c.cache.value ? c.cache.value.conditions || {} : self.conditions
            self.searchText = c.cache.value ? c.cache.value.searchText || '' : self.searchText
            self.rows = c.cache.value ? c.cache.value.rows || [] : self.rows
            self.params = c.cache.value ? c.cache.value.params || {} : self.params
            resolve()
          })
        }
      }
      self.initializeForViewer(opt)
      this.getShimeJisseki()
    },
    initSearch: function () {
      const self = this
      return new Promise(resolve => {
        if (self.isNoParam) { return resolve() }
        self.shiharaisakiCdNmText = self.params.shiharaisakiCd ? self.params.shiharaisakiCd + ':' + self.params.shiharaisakiNm : ' '
        self.eigyoshoCdNmText = self.params.eigyoshoCd ? self.params.eigyoshoCd + ':' + self.params.eigyoshoNm : ' '
        // 末日99
        var shimeDateText
        switch (self.params.shimeDay.trim()) {
          case '':
            shimeDateText = 'なし '
            break
          case '99':
            shimeDateText = '末日締め '
            break
          default:
            shimeDateText = self.params.shimeDay.trim() + '日締め '
        }
        self.shimeDateText = shimeDateText + filter.dateFormatter(self.params.shiborikomiStartYmd) + ' ～ ' + filter.dateFormatter(self.params.shiborikomiEndYmd)
        self.shiharaishoText = self.params.shiharaisho + ' / ' + self.params.shiharaiNo

        self.conditions.id = self.params.shiharaiId
        self.conditions.shiharaiYmd = filter.dateFormatter(self.params.shiharaiYmd)
        self.conditions.shiharaiYm = self.params.shimeYm ? self.params.shimeYm.trim() : ''
        self.conditions.shimeDay = self.params.shimeDay ? self.params.shimeDay.trim() : ''
        self.conditions.shiborikomiStartYmdString = filter.dateFormatter(self.params.shiborikomiStartYmd)
        self.conditions.shiborikomiEndYmdString = filter.dateFormatter(self.params.shiborikomiEndYmd)
        self.conditions.torihikisakiCd = self.params.shiharaisakiCd ? self.params.shiharaisakiCd : ''
        self.conditions.eigyoshoCd = self.params.eigyoshoCd ? self.params.eigyoshoCd : ''
        self.conditions.shiharaishoKarihakkoFlg = self.params.shiharaishoKarihakkoFlg
        self.conditions.kingakuZeroFlg = self.params.kingakuZeroFlg
        self.conditions.shiharaisho = self.params.shiharaisho
        self.conditions.shiharaiNo = self.params.shiharaiNo ? self.params.shiharaiNo.trim() : ''

        self.HttpClient.post(self.apiPathSearch, self.conditions)
          .then((data) => {
            self.setHeader().then(() => {
              self.searchResultMethodCustom(data)
              resolve(data)
            })
          })
      })
    },
    searchResultMethodCustom: function (data) {
      const self = this
      self.rows = []
      // 取消済以外の場合のみ明細表示（取消は明細表示しない）
      if (!self.isShiharaiTorikeshi) {
        // vw_c_d2bild1020だけではないので、配列を分けて設定される
        self.rows = data.payload.vwCD2payd1020List || []
      }
      self.rows.map((elem, index) => {
        elem.rowNo = index + 1
        elem.editFlg = false
        elem.errFlg = false
        // スプレッドシート用編集
        // ※数値はsetHeaderにてmask対応済み
        elem.sagyoYoteiYmd = [undefined, null, ''].includes(elem.sagyoYoteiYmd) ? '' : filter.dateFormatter(elem.sagyoYoteiYmd)
        elem.shiharaiYoteiYmd = [undefined, null, ''].includes(elem.shiharaiYoteiYmd) ? '' : filter.dateFormatter(elem.shiharaiYoteiYmd)
        elem.hatsuchiYmd = ![undefined, null, ''].includes(elem.hatsuchiYmd) ? filter.dateFormatter(elem.hatsuchiYmd) : ''
        elem.hatsuchiHms = ![undefined, null, ''].includes(elem.hatsuchiHms) ? (elem.hatsuchiHms).slice(0, 5) : ''
        elem.chakuchiYmd = ![undefined, null, ''].includes(elem.chakuchiYmd) ? filter.dateFormatter(elem.chakuchiYmd) : ''
        elem.chakuchiHms = ![undefined, null, ''].includes(elem.chakuchiHms) ? (elem.chakuchiHms).slice(0, 5) : ''
        elem.hatsuchiNm = [undefined, null, ''].includes(elem.hatsuchiNm) ? '' : elem.hatsuchiNm
        elem.chakuchiNm = [undefined, null, ''].includes(elem.chakuchiNm) ? '' : elem.chakuchiNm
        elem.hinmeiNm = [undefined, null, ''].includes(elem.hinmeiNm) ? '' : elem.hinmeiNm
        elem.unitKbnNm = [undefined, null, ''].includes(elem.unitKbnNm) ? '' : elem.unitKbnNm
        elem.unchinKeisanKbnNm = [undefined, null, ''].includes(elem.unchinKeisanKbnNm) ? '' : elem.unchinKeisanKbnNm
        elem.shiharaiShashuSbtNm = [undefined, null, ''].includes(elem.shiharaiShashuSbtNm) ? '' : elem.shiharaiShashuSbtNm
        elem.tanka = elem.unchinKeisanKbn === '03' ? self.computedColNumList.hinmokuKihonUnchin ? elem.hinmokuKihonUnchin : elem.meisaiKihonUnchin : elem.tanka

        // 支払金額関数埋め込み
        const y = index + 1
        elem.shiharaiKingakuGokeiFormula = ![undefined, null, ''].includes(self.shiharaiKingakuGokeiFormula) ? '=' + self.shiharaiKingakuGokeiFormula.replaceAll('{rowNo}', `${y}`) : ''

        return elem
      })

      self.$nextTick(() => {
        const fixedHeaderColumns = self.headers.filter(x => x.fixedHeader).length
        self.$refs.ddSpreadSheet.setFreezeColumns(fixedHeaderColumns > 0 ? fixedHeaderColumns : 2)
      })

      var initshiharaiKihon = {
        konkaiShiharaiKingaku: 0,
        kihonUnchiGokei: 0,
        warimashiKingakuGokei: 0,
        kazeiKingakuGokei: 0,
        konkaiTax: 0,
        hiwayPriceGokei: 0,
        uchizeiKingakuGokei: 0,
        hikazeiKingakuGokei: 0
      }
      var initMstShiharaisaki = {
        shiharaishoLayoutKbn: false,
        shiharaiMeisaishoLayoutKbn: false
      }

      // 傭車明細基本情報
      if (!self.isShiharai) {
        // 未傭車明細（受注情報）の場合
        self.shiharaiKihon = data.payload.wkshiharaiKihon || initshiharaiKihon
      } else {
        // 傭車明細済（傭車明細情報）の場合
        self.shiharaiKihon = data.payload.trshiharaiKihon || initshiharaiKihon
      }
      // 傭車明細先マスタ情報
      self.shiharaisaki = data.payload.mstShiharaisaki || initMstShiharaisaki
      // 傭車明細消込存在確認
      self.isExistsKeshikomi = data.payload.isExistsKeshikomi || false

      const cache = {
        rows: self.rows,
        conditions: self.conditions,
        searchText: self.searchText,
        params: self.params
      }
      self.saveToChache(cache)
        .then(() => {
        })
    },
    onSearchButtonClick: function (e) {
      const self = this
      const opt = {
        searchRequestPromise: function () {
          return new Promise(resolve => {
            self.HttpClient.post(self.apiPathSearch, self.conditions)
              .then((data) => {
                resolve(data)
              })
          })
        },
        searchResultMethod: function (data) {
          self.searchResultMethodCustom(data)
        },
        getSavedInputMethod: function () {
          if (!self.isShiharai) {
            // 未傭車明細時のみの項目
            return {
              kingakuKakutei: self.conditions.kingakuKakutei,
              shimebiIgaiHyojiFlg: self.conditions.shimebiIgaiHyojiFlg,
              shiharaiDomeHyojiFlg: self.conditions.shiharaiDomeHyojiFlg
            }
          } else {
            return {}
          }
        },
        isNoMessageModeMethod: function () {
          return true
        }
      }
      this.search(opt)
    },
    onReturnButtonClick: function (e) {
      console.log('onReturnButtonClick', e)
      const self = this
      const opt = {
        getTransitionBackParams: function () {
          return {
            actionId: 0,
            param: self.params
          }
        }
      }

      this.transitionBack(opt)
    },

    /**
     * outputInfo.StyleTypeについて
     * 11:かんたん日報 / 12:通常日報 : VwCD2payd1020Model.ExcelOperation参照
     */
    onXlsOutputButtonClick: function (e) {
      this.isXlsDownloader = true

      var hacchuMeisaiIdList = []
      this.rows.forEach((x) => {
        hacchuMeisaiIdList.push(x.trHacchuMeisaiId)
      })
      const outputInfo = {
        idList: hacchuMeisaiIdList,
        styleType: this.nippoStyleNormal ? 'D2PAYD1021' : 'D2PAYD1020'
      }

      this.HttpClient
        .requestFileByPost('/api/v1/VwCD2payd1020/ExcelOutput', outputInfo)
        .then((data) => {
          const ts = date.getCurrentDate().replaceAll('/', '') + '_' + date.getCurrentTime().replaceAll(':', '')
          const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
          const elem = document.getElementById('xlsdownload')
          this.isXlsDownloader = false
          elem.href = window.URL.createObjectURL(blob)
          elem.download = '傭車明細一覧_' + ts + '.xlsx'
          elem.click()
        })
    },

    /**
     * スプレッドシート制御
     * @returns
     */
    setHeader: function () {
      console.log('setHeader')
      const self = this
      return new Promise(resolve => {
        // 現在日付取得
        const target = filter.dateFormatter(new Date())

        // --------------------------------------------------------------------------------
        // スプレッド用ドロップダウン作成
        // --------------------------------------------------------------------------------
        // 得意先
        var wkYoshasakiList = ['未選択']
        const mTokuisakiList = this.torihikisakiList.map((elem) => {
          elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
          elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
          return elem
        }).filter((t) => {
          return t.tekiyoStartYmdDisp <= target && t.tekiyoEndYmdDisp >= target
        })
        const tTokuisakiList = mTokuisakiList.map(elem => {
          return elem.torihikisakiNm
        })
        wkYoshasakiList = wkYoshasakiList.concat(tTokuisakiList)

        // 荷受人
        var wkNiukeninList = ['未選択']
        const mNiukeninList = self.torihikisakiList.map((elem) => {
          elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
          elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
          return elem
        }).filter((t) => {
          return t.tekiyoStartYmdDisp <= target && t.tekiyoEndYmdDisp >= target
        })
        const tNiukeninList = mNiukeninList.map(elem => {
          return elem.torihikisakiNm
        })
        wkNiukeninList = wkNiukeninList.concat(tNiukeninList)

        // 発着地
        var wkHacchakuchiList = ['未選択']
        const mHacchakuchiList = self.hacchakuchiList.map((elem) => {
          elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
          elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
          return elem
        }).filter((t) => {
          return t.tekiyoStartYmdDisp <= target && t.tekiyoEndYmdDisp >= target
        })
        const tHacchakuchiList = mHacchakuchiList.map(elem => {
          return elem.hacchakuchiNm
        })
        wkHacchakuchiList = wkHacchakuchiList.concat(tHacchakuchiList)

        // 発地
        var wkHatsuchiList = ['未選択']
        const mHatsuchiList = self.hacchakuchiList.map((elem) => {
          elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
          elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
          return elem
        }).filter((t) => {
          return t.tekiyoStartYmdDisp <= target && t.tekiyoEndYmdDisp >= target && t.hatsuchiFlg
        })
        const tHatsuchiList = mHatsuchiList.map(elem => {
          return elem.HatsuchiNm
        })
        wkHatsuchiList = wkHatsuchiList.concat(tHatsuchiList)

        // 経由地
        var wkKeiyuchiList = ['未選択']
        const mKeiyuchiList = self.hacchakuchiList.map((elem) => {
          elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
          elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
          return elem
        }).filter((t) => {
          return t.tekiyoStartYmdDisp <= target && t.tekiyoEndYmdDisp >= target && t.keiyuchiFlg
        })
        const tKeiyuchiList = mKeiyuchiList.map(elem => {
          return elem.KeiyuchiNm
        })
        wkKeiyuchiList = wkKeiyuchiList.concat(tKeiyuchiList)

        // 着地
        var wkChakuchiList = ['未選択']
        const mChakuchiList = self.hacchakuchiList.map((elem) => {
          elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
          elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
          return elem
        }).filter((t) => {
          return t.tekiyoStartYmdDisp <= target && t.tekiyoEndYmdDisp >= target && t.chakuchiFlg
        })
        const tChakuchiList = mChakuchiList.map(elem => {
          return elem.ChakuchiNm
        })
        wkChakuchiList = wkChakuchiList.concat(tChakuchiList)

        // 商品
        var wkShohinList = ['未選択']
        const mShohinList = this.hinmeiList.map((elem) => {
          elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
          elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
          return elem
        }).filter((t) => {
          return t.tekiyoStartYmdDisp <= target && t.tekiyoEndYmdDisp >= target
        })
        const tShohinList = mShohinList.map(elem => {
          return elem.hinmeiNm
        })
        wkShohinList = wkShohinList.concat(tShohinList)

        // 品目種別
        var wkHinmokuShubetsuList = ['未選択']
        const mHinmokuShubetsuList = self.shubetsuList.filter((elem) => {
          return elem.sbtShuruiCd === 'GVIJ02' && elem.kaishaCd === self.currentKaishaCode
        })
        const tHinmokuShubetsuList = mHinmokuShubetsuList.map(elem => {
          return elem.sbtNm
        })
        wkHinmokuShubetsuList = wkHinmokuShubetsuList.concat(tHinmokuShubetsuList)

        // 単位
        var wkTaniShubetsuList = ['未選択']
        const mTaniShubetsuList = this.shubetsuList.filter((elem) => {
          return elem.sbtShuruiCd === 'SVI001' && elem.kaishaCd === this.currentKaishaCode
        })
        const tTaniShubetsuList = mTaniShubetsuList.map(elem => {
          return elem.sbtNm
        })
        wkTaniShubetsuList = wkTaniShubetsuList.concat(tTaniShubetsuList)

        // 運賃計算区分
        var wkUnchinKeisanKubunList = ['未選択']
        const mUnchinKeisanKubunList = this.kubunList.filter((elem) => {
          return elem.kbnShuruiCd === 'SFF055' && elem.kaishaCd === this.currentKaishaCode && ['01', '02', '03'].includes(elem.code)
        })
        const tUnchinKeisanKubunList = mUnchinKeisanKubunList.map(elem => {
          return elem.codeNm
        })
        wkUnchinKeisanKubunList = wkUnchinKeisanKubunList.concat(tUnchinKeisanKubunList)

        // 傭車明細車種
        var wkYoshaShashuShubetsuList = ['未選択']
        const mSeikyuShashuShubetsuList = this.shubetsuList.filter((elem) => {
          return elem.sbtShuruiCd === 'GVI011' && elem.kaishaCd === this.currentKaishaCode
        })
        const tSeikyuShashuShubetsuList = mSeikyuShashuShubetsuList.map(elem => {
          return elem.sbtNm
        })
        wkYoshaShashuShubetsuList = wkYoshaShashuShubetsuList.concat(tSeikyuShashuShubetsuList)

        // --------------------------------------------------------------------------------
        // スプレッド用ヘッダ作成
        // --------------------------------------------------------------------------------
        if (![undefined, null, []].includes(self.headers) && self.headers.length > 0) { return resolve() }

        self.headers = []

        // マスタ情報から自動生成
        self.xlsImportMappingList.filter(function (elem) {
          return elem.formatCd === self.headerType && elem.hyojiFlg === true
        }).sort((a, b) => {
          if (a.columnNo - b.columnNo !== 0) { return a.columnNo - b.columnNo }
          return -1
        }).forEach((elem) => {
          var dropdownList = null
          if (elem.source === 'YoshasakiList') {
            dropdownList = wkYoshasakiList
          } else if (elem.source === 'NiukeninList') {
            dropdownList = wkNiukeninList
          } else if (elem.source === 'HacchakuchiList') {
            dropdownList = wkHacchakuchiList
          } else if (elem.source === 'HatsuchiList') {
            dropdownList = wkHatsuchiList
          } else if (elem.source === 'KeiyuchiList') {
            dropdownList = wkKeiyuchiList
          } else if (elem.source === 'ChakuchiList') {
            dropdownList = wkChakuchiList
          } else if (elem.source === 'ShohinList') {
            dropdownList = wkShohinList
          } else if (elem.source === 'HinmokuShubetsuList') {
            dropdownList = wkHinmokuShubetsuList
          } else if (elem.source === 'TaniSbtList') {
            dropdownList = wkTaniShubetsuList
          } else if (elem.source === 'UnchinKeisanKbnList') {
            dropdownList = wkUnchinKeisanKubunList
          } else if (elem.source === 'ShashuSbtList') {
            dropdownList = wkYoshaShashuShubetsuList
          }

          // 支払金額計算用定義
          if (elem.bindItemNm === 'shiharaiKingakuGokeiFormula') {
            self.shiharaiKingakuGokeiFormula = elem.formulaStrings
          }

          // ヘッダー作成
          self.headers.push({
            title: elem.columnNm,
            name: elem.bindItemNm,
            type: elem.standardInputFlg !== true ? null : elem.inputType,
            customInput: elem.standardInputFlg === true ? null : elem.inputType,
            validateType: elem.validateType,
            required: false,
            isRequired: elem.requiredFlg,
            readOnly: elem.readonlyFlg,
            autocomplete: elem.autocompleteFlg,
            width: elem.width + 'px',
            source: dropdownList,
            align: elem.align,
            mask: elem.inputSuffix,
            validateIntDigit: elem.inputIntDigit,
            validateDecimalDigit: elem.inputDecimalDigit,
            // headerStyle: elem.headerStyle === null ? undefined : elem.headerStyle,
            tooltip: elem.requiredFlg ? '必須項目' : undefined,
            columnNo: elem.columnNo,
            fixedHeader: elem.fixedHeaderFlg
          })
        })
        resolve()
      })
    },
    /**
     * 品名ドロップダウン設定
     */
    setHinmeiCellSettings: function (colIndex, rowIndex, column) {
      const self = this
      // 現在日付取得
      const target = filter.dateFormatter(new Date())

      // 品目種別返還
      const m = self.shubetsuList.filter(function (item) {
        return item.kaishaCd === self.currentKaishaCode && item.sbtShuruiCd === 'GVIJ02' && item.sbtNm === self.rows[rowIndex].hinmokuSbtNm
      })
      const hinshuSbt = m.length > 0 ? m[0].sbtCd : null

      // 商品
      var wkShohinList = ['未選択']
      const mShohinList = this.hinmeiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter((t) => {
        return t.tekiyoStartYmdDisp <= target && t.tekiyoEndYmdDisp >= target && ([undefined, null, '', hinshuSbt].includes(t.hinshuSbt) || hinshuSbt === null)
      })
      const tShohinList = mShohinList.map(elem => {
        return elem.hinmeiNm
      })
      wkShohinList = wkShohinList.concat(tShohinList)

      // 品名セルの設定
      this.$refs.ddSpreadSheet.jspreadsheetObj.setProperty(this.computedColNumList.hinmeiNm, rowIndex, {
        ...column,
        type: 'dropdown',
        autocomplete: true,
        source: wkShohinList
      })
    },
    // セル変更時
    onSetCustomCell: function (cell, x, y, value, row, column) {
      if (this.computedColNumList.hinmokuSbtNm === Number(x)) {
        const targetColumn = this.headers.find(item => item.name === 'hinmeiNm')
        this.setHinmeiCellSettings(Number(x), y, targetColumn)
      }
    },
    /**
     * 読み取り専用設定
     */
    setReadonlyCell: function (rowData, columnName) {
      if (this.isShoukaiMode) {
        return true
      }
      if (['juchuNo'].includes(columnName)) {
        return true
      }

      return false
    },
    // 行追加
    addRow: function (pos) {
      console.log('addRow')
    },
    // 行削除
    deleteRow: function (pos) {
      console.log('deleteRow')
    },
    /**
     * スプレッドシート変更後イベント
     * @param {*} rowData
     * @param {*} cell
     * @param {*} x
     * @param {*} y
     * @param {*} newValue
     * @param {*} oldValue
     */
    changeAfter (rowData, cell, x, y, newValue, oldValue) {
      // console.log('c', rowData, cell, x, y, newValue, oldValue)

      /*
        支払金額自動計算
       */
      if (this.computedColNumList.hinmokuKihonUnchin || this.computedColNumList.meisaiKihonUnchin) {
        const t = this.kubunList.filter((elem) => {
          return elem.kbnShuruiCd === 'SFF055' && elem.kaishaCd === this.currentKaishaCode
        }).find(x => x.codeNm === this.rows[y].unchinKeisanKbnNm)
        const tUnchinKeisanKbn = t ? t.code : '03'
        const hinmoku = this.computedColNumList.hinmokuKihonUnchin ? 'hinmoku' : ''

        if (Number(x) === this.computedColNumList.juchuSuryo) {
          this.calcKihonUnchinByQuantity(Number(y), hinmoku)
        }
        if (Number(x) === this.computedColNumList.juchuJuryo) {
          this.calcKihonUnchinByWeight(Number(y), hinmoku)
        }
        if (Number(x) === this.computedColNumList.unchinKeisanKbnNm) {
          if (tUnchinKeisanKbn === '01') {
            this.calcKihonUnchinByQuantity(Number(y), hinmoku)
          } else if (tUnchinKeisanKbn === '02') {
            this.calcKihonUnchinByWeight(Number(y), hinmoku)
          } else {
            this.calcKihonUnchinByCharter(Number(y), hinmoku)
          }
        }
        if (Number(x) === this.computedColNumList.tanka) {
          if (tUnchinKeisanKbn === '01') {
            this.calcKihonUnchinByQuantity(Number(y), hinmoku)
          } else if (tUnchinKeisanKbn === '02') {
            this.calcKihonUnchinByWeight(Number(y), hinmoku)
          } else {
            this.calcKihonUnchinByCharter(Number(y), hinmoku)
          }
        }
      }
    },
    calcKihonUnchinByQuantity: function (y, hinmoku) {
      if (![undefined, null, ''].includes(this.rows[y].juchuSuryo) && ![undefined, null, ''].includes(this.rows[y].tanka)) {
        let cell
        const t = this.rows[y].juchuSuryo * this.rows[y].tanka
        if (![undefined, null, ''].includes(hinmoku)) {
          cell = this.$refs.ddSpreadSheet.getCellNameFromCoords(this.computedColNumList.hinmokuKihonUnchin, y)
        } else {
          cell = this.$refs.ddSpreadSheet.getCellNameFromCoords(this.computedColNumList.meisaiKihonUnchin, y)
        }
        this.$refs.ddSpreadSheet.jspreadsheetObj.setValue(cell, Math.round(t), true)
      }
    },
    calcKihonUnchinByWeight: function (y, hinmoku) {
      if (![undefined, null, ''].includes(this.rows[y].juchuJuryo) && ![undefined, null, ''].includes(this.rows[y].tanka)) {
        let cell
        const t = this.rows[y].juchuJuryo * this.rows[y].tanka
        if (![undefined, null, ''].includes(hinmoku)) {
          cell = this.$refs.ddSpreadSheet.getCellNameFromCoords(this.computedColNumList.hinmokuKihonUnchin, y)
        } else {
          cell = this.$refs.ddSpreadSheet.getCellNameFromCoords(this.computedColNumList.meisaiKihonUnchin, y)
        }
        this.$refs.ddSpreadSheet.jspreadsheetObj.setValue(cell, Math.round(t), true)
      }
    },
    calcKihonUnchinByCharter: function (y, hinmoku) {
      if (![undefined, null, ''].includes(this.rows[y].tanka)) {
        let cell
        if (![undefined, null, ''].includes(hinmoku)) {
          cell = this.$refs.ddSpreadSheet.getCellNameFromCoords(this.computedColNumList.hinmokuKihonUnchin, y)
        } else {
          cell = this.$refs.ddSpreadSheet.getCellNameFromCoords(this.computedColNumList.meisaiKihonUnchin, y)
        }
        this.$refs.ddSpreadSheet.jspreadsheetObj.setValue(cell, Math.round(this.rows[y].tanka), true)
      }
    },
    //
    onClickSave: function () {
      console.log(this.rows)
    },
    onChangeListType: function (type) {
      this.nippoStyleNormal = type
      if (type) {
        this.headerType = 'D2PAYD1021'
      } else {
        this.headerType = 'D2PAYD1020'
      }
      const p = Object.assign([], this.rows)
      this.headers = []
      this.rows = []
      this.setHeader().then(() => {
        this.rows = Object.assign([], p)
        this.rows.map((elem, index) => {
          // 支払金額関数埋め込み
          const y = index + 1
          elem.shiharaiKingakuGokeiFormula = ![undefined, null, ''].includes(this.shiharaiKingakuGokeiFormula) ? '=' + this.shiharaiKingakuGokeiFormula.replaceAll('{rowNo}', `${y}`) : ''
          return elem
        })
        this.$nextTick(() => {
          const fixedHeaderColumns = this.headers.filter(x => x.fixedHeader).length
          this.$refs.ddSpreadSheet.setFreezeColumns(fixedHeaderColumns > 0 ? fixedHeaderColumns : 2)
        })
      })
    },
    onCancelButtonClick: function () {
      // 月次確定処理を行ったデータだった場合、エラー
      if (this.shiharaiKihon.trKessanGetsujiKanriId) {
        this.setInvalidSummaryMessage('BZME0001')
        return false
      }
      const p = modals.showConfirm
      p('COMQ0003').then((ok) => {
        if (ok === false || ok === undefined) { return }
        this.Effects.loadStart()
        var list = []
        list.push(this.conditions)
        this.HttpClient.post('/api/v1/d2payd0010/shiharaicancel', list)
          .then((data) => {
            if (data.payload) {
              // 取消処理が正常に終了した場合
              this.params.shiharaisho = '取消済'
            }
            // 画面再表示
            this.initialize()
            // 完了処理
            // this.Effects.loadComplete()
            this.setInvalidSummaryMessage('COMI0005')
          })
      })
    },
    onPrintButtonClick: function (shiharaishoKarihakkoFlg) {
      console.log('onPrintButtonClick')
      if (this.lastShimeYmd !== '') {
        if (this.shiharaiKihon.shiharaiYmd <= this.lastShimeYmd) {
          this.setInvalidSummaryMessage('BZME0001')
          return false
        }
      }
      this.loadFromCache()
        .then((c) => {
          if (!this.isShiharai) {
            // 未傭車明細（受注情報）の場合
            var msgInfo = {}
            if (c.value.conditions.shimebiIgaiHyojiFlg) {
              // 再検索を促すメッセージを表示
              msgInfo = JSON.parse(JSON.stringify(message.getInfo('PAYE0005')))
              msgInfo.message = message.get('PAYE0005', ['締日以外の未支払も表示する'])
              this.setSummaryMessage(msgInfo)
              return false
            }
            if (c.value.conditions.shiharaiDomeHyojiFlg) {
              // 再検索を促すメッセージを表示
              msgInfo = JSON.parse(JSON.stringify(message.getInfo('PAYE0005')))
              msgInfo.message = message.get('PAYE0005', ['支払止も表示する'])
              this.setSummaryMessage(msgInfo)
              return false
            }
          }
          this.Effects.loadStart()
          this.dispShiharaisho = `傭車明細書_${this.getTimeStamp()}.pdf`
          // 傭車明細番号は画面再検索時のキーとなりうる項目のため、帳票出力（傭車明細作成）後に対象となった傭車明細番号を取得する必要がある
          var conditions = JSON.parse(JSON.stringify(c.value.conditions))
          var pathPrint = ''
          var pathNoPrint = ''
          if (shiharaishoKarihakkoFlg) {
            // 傭車明細書仮発行の場合
            conditions.shiharaishoKarihakkoFlg = true
            pathPrint = '/api/v1/d2payd0010/printpaymentkari'
            pathNoPrint = '/api/v1/d2payd0010/createshiharaidatakari'
          } else {
            // 傭車明細書発行の場合
            pathPrint = '/api/v1/d2payd0010/printpayment'
            pathNoPrint = '/api/v1/d2payd0010/createshiharaidata'
          }

          if (this.isNotExistShiharaishoLayoutKbn) {
            // 傭車明細レイアウト区分が設定されていない場合
            return this.HttpClient
              // 発行処理前の支払No一覧を取得
              .post('/api/v1/d2payd0020/searchshiharainofromshiharai', conditions)
              .then((before) => {
                var beforeResult = before.payload || []
                this.HttpClient
                  // 非帳票出力処理（傭車明細作成のみ）
                  .post(pathNoPrint, c.value.conditions)
                  .then(data => {
                    // 発行処理後の支払No一覧を取得（発行処理対象の支払Noを抽出）
                    this.searchShiharaiNoAfter(c, conditions, shiharaishoKarihakkoFlg, beforeResult)
                  })
              })
          } else {
            return this.HttpClient
              // 発行処理前の傭車明細No一覧を取得
              .post('/api/v1/d2payd0020/searchshiharainofromshiharai', conditions)
              .then((before) => {
                var beforeResult = before.payload || []
                this.HttpClient
                  // 帳票出力処理
                  .requestFileByPost(pathPrint, c.value.conditions)
                  .then(data => {
                    // aタグにファイル仕込んでClickする処理
                    const blob = new Blob([data], { type: 'application/pdf' })
                    const elem = document.getElementById('shiharaishoDownload')
                    elem.href = window.URL.createObjectURL(blob)
                    elem.click()
                    // 発行処理後の傭車明細No一覧を取得（発行処理対象の傭車明細Noを抽出）
                    this.searchShiharaiNoAfter(c, conditions, shiharaishoKarihakkoFlg, beforeResult)
                  })
              })
          }
        })
    },
    searchShiharaiNoAfter: function (c, conditions, shiharaishoKarihakkoFlg, beforeResult) {
      this.HttpClient
        .post('/api/v1/d2payd0020/searchshiharainofromshiharai', conditions)
        .then((after) => {
          var afterResult = after.payload || []
          var result = afterResult.filter((elem) => {
            return beforeResult.indexOf(elem) === -1
          })
          if (result.length > 0) {
            // 支払情報が作成された場合
            // paramsの値を処理後の情報に更新
            this.params.shiharaisho = '出力済'
            // 支払番号を取得
            this.params.shiharaiNo = result[0]
            if (shiharaishoKarihakkoFlg) {
              // 支払書仮発行の場合
              this.params.shiharaishoKarihakkoFlg = true
            }
            // 画面再検索のために再キャッシュ
            const cache = {
              rows: c.value.rows,
              conditions: c.value.conditions,
              searchText: c.value.searchText,
              params: this.params
            }
            this.saveToChache(cache)
              .then(() => {
              })
            // 画面再表示
            this.initialize()
            // 完了処理
            // this.Effects.loadComplete()
            this.setInvalidSummaryMessage('COMI0005')
          } else {
            // 完了処理
            this.Effects.loadComplete()
            this.setInvalidSummaryMessage('COMI0005')
          }
        })
    },
    onPrintAgainButtonClick: function () {
      console.log('onPrintAgainButtonClick')
      this.Effects.loadStart()
      this.dispShiharaisho = `傭車明細書_${this.getTimeStamp()}.pdf`
      var path = '/api/v1/d2payd0010/printpaymentagain'
      if (this.isNotExistShiharaishoLayoutKbn) {
        // 支払レイアウト区分が設定されていない場合
        // 完了処理
        this.Effects.loadComplete()
        this.setInvalidSummaryMessage('COMI0005')
      } else {
        return this.HttpClient
          .requestFileByPost(path, this.conditions)
          .then(data => {
            // aタグにファイル仕込んでClickする処理
            const blob = new Blob([data], { type: 'application/pdf' })
            const elem = document.getElementById('shiharaishoDownload')
            elem.href = window.URL.createObjectURL(blob)
            elem.click()
            // // 画面再表示
            // this.initialize()
            // 完了処理
            this.Effects.loadComplete()
            this.setInvalidSummaryMessage('COMI0005')
          })
      }
    },
    searchValidate: function () {
      return true
    },
    getTimeStamp () {
      var date = new Date()
      const Y = date.getFullYear()
      const M = ('00' + (date.getMonth() + 1)).slice(-2)
      const D = ('00' + date.getDate()).slice(-2)
      const h = ('00' + date.getHours()).slice(-2)
      const m = ('00' + date.getMinutes()).slice(-2)
      const s = ('00' + date.getSeconds()).slice(-2)

      return Y + M + D + h + m + s
    },
    getShimeJisseki: function () {
      return new Promise((resolve) => {
        this.HttpClient
          .get('/api/v1/TrKessanGetsujiKanri/GetAll')
          .then((data) => {
            if (data.payload) {
              var shiharaiShimeList = data.payload.map((elem) => {
                elem.taishoShimeYmd = new Date(elem.taishoYm + '/' + elem.taishoShimeDay)
                return elem
              }).filter(function (elem) {
                return elem.taishoGyomuCd === '02' && elem.delFlg === false
              })
              this.lastShimeYmd = shiharaiShimeList.length !== 0 ? filter.dateFormatter(shiharaiShimeList[shiharaiShimeList.length - 1].taishoShimeYmd) : ''
            }
            resolve()
          })
      })
    },

    /**
     * 保存処理（ソースが酷いのでそのうち直す）
     * @returns
     */
    onSaveButtonClick: function () {
      const self = this

      // 傭車明細書発行済みの場合は保存処理を実行させない
      if (![undefined, null, ''].includes(this.conditions.shiharaiNo)) {
        modals.showAlert('BILI0001')
        return
      }

      // 変更フラグONのみ対象
      const saveTargetRow = this.rows.filter(function (elem) {
        return elem.editFlg === true && elem.errFlg !== true
      })
      if (saveTargetRow.length < 1) {
        modals.showAlert('COMI0010')
        return
      }

      const parm = [saveTargetRow.length]
      modals.showConfirmYesNo('COMQ0013', null, null, parm).then((ok) => {
        // 処理を続行しない場合は終了
        if (ok === true) {
          /**
           * リスト項目テキスト⇒ID/Code変換
           */
          // 荷受人
          saveTargetRow.filter((elem) => {
            return ![undefined, null].includes(elem.niukeninNm)
          }).map((elem) => {
            const m = self.torihikisakiList.filter(function (item) {
              return item.torihikisakiNm === elem.niukeninNm
            })
            if (m.length > 0) {
              elem.niukeninId = m[0].id
            } else {
              elem.niukeninId = null
            }
            return elem
          })
          // 発地
          saveTargetRow.filter((elem) => {
            return ![undefined, null, ''].includes(elem.hatsuchiNm)
          }).map((elem) => {
            const m = self.hacchakuchiList.filter(function (item) {
              return item.hacchakuchiNm === elem.hatsuchiNm
            })
            if (m.length > 0) {
              elem.hatsuchiId = m[0].id
            } else {
              elem.hatsuchiId = null
            }
            return elem
          })

          // 着地
          saveTargetRow.filter((elem) => {
            return ![undefined, null, ''].includes(elem.chakuchiNm)
          }).map((elem) => {
            const m = self.hacchakuchiList.filter(function (item) {
              return item.hacchakuchiNm === elem.chakuchiNm
            })
            if (m.length > 0) {
              elem.chakuchiId = m[0].id
            } else {
              elem.chakuchiId = null
            }
            return elem
          })

          // 品目種別
          saveTargetRow.filter((elem) => {
            return ![undefined, null].includes(elem.hinmokuSbtNm)
          }).map((elem) => {
            const m = self.shubetsuList.filter(function (item) {
              return item.kaishaCd === self.currentKaishaCode && item.sbtShuruiCd === 'GVIJ02' && item.sbtNm === elem.hinmokuSbtNm
            })
            if (m.length > 0) {
              elem.hinmokuSbt = m[0].sbtCd
            } else {
              elem.hinmokuSbt = null
            }
            return elem
          })

          // 商品
          saveTargetRow.filter((elem) => {
            return ![undefined, null, ''].includes(elem.hinmeiNm)
          }).map((elem) => {
            const m = self.hinmeiList.filter(function (item) {
              return item.hinmeiNm === elem.hinmeiNm
            })
            if (m.length > 0) {
              elem.mstHinmeiId = m[0].id
            } else {
              elem.mstHinmeiId = null
            }
            return elem
          })

          // 単位
          saveTargetRow.filter((elem) => {
            return ![undefined, null, ''].includes(elem.unitKbnNm)
          }).map((elem) => {
            const m = self.shubetsuList.filter(function (item) {
              return item.kaishaCd === self.currentKaishaCode && item.sbtShuruiCd === 'SVI001' && item.sbtNm === elem.unitKbnNm
            })
            if (m.length > 0) {
              elem.unitKbn = m[0].sbtCd
            } else {
              elem.unitKbn = null
            }
            return elem
          })

          // 運賃計算区分
          saveTargetRow.filter((elem) => {
            return ![undefined, null, ''].includes(elem.unchinKeisanKbnNm)
          }).map((elem) => {
            const m = self.kubunList.filter(function (item) {
              return item.kaishaCd === self.currentKaishaCode && item.kbnShuruiCd === 'SFF055' && item.codeNm === elem.unchinKeisanKbnNm
            })
            if (m.length > 0) {
              elem.unchinKeisanKbn = m[0].code
            } else {
              elem.unchinKeisanKbn = null
            }
            return elem
          })

          // 傭車明細車種
          saveTargetRow.filter((elem) => {
            return ![undefined, null, ''].includes(elem.shiharaiShashuSbtNm)
          }).map((elem) => {
            const m = self.shubetsuList.filter(function (item) {
              return item.kaishaCd === self.currentKaishaCode && item.sbtShuruiCd === 'GVI011' && item.sbtNm === elem.shiharaiShashuSbtNm
            })
            if (m.length > 0) {
              elem.shiharaiShashuSbt = m[0].sbtCd
            } else {
              elem.shiharaiShashuSbt = null
            }
            return elem
          })

          /**
           * 保存処理
           */
          this.targetList = saveTargetRow
          this.$nextTick(function () {
            self.saveAction()
          })
        }
      })
    },
    saveAction: function () {
      const self = this
      const opt = {
        registerRequestPromise: function () {
          return self.HttpClient.post('/api/v1/d2payd0020/BulkRegistration', self.targetList)
        },
        registerResponsePromise: (data) => {
          return new Promise(resolve => {
            self.Effects.loadComplete()
            if (data.isValid) {
              var param = [data.payload.length]
              this.$nextTick(function () {
                modals.showAlertOk('BILI0002', null, null, param).then((ok) => {
                  this.onSearchButtonClick()
                })
              })
            }
            resolve()
          })
        },
        getIdMethod: () => {
          return 0
        },
        continuousInputInitializePromise: (id) => {
          return new Promise(resolve => {
            resolve()
          })
        },
        getTransitionBackParams: function () {
          return {
            actionId: 0
          }
        },
        isUpdateModeMethod: function () {
          return true
        },
        isNoRefreshModeMethod: function () {
          return true
        },
        isNoMessageModeMethod: function () {
          return false
        },
        getSavedInputMethod: function () {
          return true
        }
      }
      this.register(opt)
    },
    // 登録前チェック
    registerValidate: function () {
      const self = this
      /*
      const filledRows = this.rows
        .map((row, rowIndex) => ({ row, rowIndex }))
        .filter(({ row }) =>
          Object.values(row).some(value => value !== null && value !== '')
        )
      */
      const filledRows = this.rows.filter(function (elem) {
        return elem.editFlg === true && elem.errFlg !== true
      })

      let noProblem = true

      filledRows.forEach((row, rowIndex) => {
        self.headers.forEach((col, colIndex) => {
          if (col.isRequired) {
            const cellValue = row[col.name]
            const isEmpty = cellValue === null || cellValue === ''
            const cellName = self.$refs.ddSpreadSheet.getCellNameFromCoords(colIndex, row.rowNo - 1)

            if (isEmpty) {
              noProblem = false
              // 見た目にわかるよう赤背景をつける
              self.$refs.ddSpreadSheet.jspreadsheetObj.setStyle(cellName, 'background-color', '#ffcccc')
            } else {
              // 問題なければ背景を戻す（任意）
              self.$refs.ddSpreadSheet.jspreadsheetObj.setStyle(cellName, 'background-color', '')
            }
          }
        })
      })

      return noProblem
    }
  }
}
